import { CheckCircle, XCircle, AlertCircle, X } from 'lucide-react';

interface ToastProps {
  notification: {
    message: string;
    type: 'success' | 'error' | 'info';
  } | null;
  onClose: () => void;
}

export const Toast = ({ notification, onClose }: ToastProps) => {
  if (!notification) return null;

  const bgColors = {
    success: 'bg-green-100 border-green-200 text-green-800',
    error: 'bg-red-100 border-red-200 text-red-800',
    info: 'bg-blue-100 border-blue-200 text-blue-800',
  };

  const icons = {
    success: <CheckCircle size={20} className="text-green-600" />,
    error: <XCircle size={20} className="text-red-600" />,
    info: <AlertCircle size={20} className="text-blue-600" />,
  };

  return (
    <div
      className={`fixed top-4 left-1/2 -translate-x-1/2 z-[60] flex items-center gap-3 px-4 py-3 rounded-lg shadow-lg border ${bgColors[notification.type]} animate-in slide-in-from-top-2 fade-in duration-300`}
    >
      {icons[notification.type]}
      <p className="font-medium text-sm">{notification.message}</p>
      <button onClick={onClose} className="ml-2 hover:opacity-70">
        <X size={16} />
      </button>
    </div>
  );
};
